module.exports = __webpack_public_path__ + "img/banner3.b6c9bbd7.png";